import React from 'react';

import { DynamicProductTable } from '../_dynamic';
import { ProductTableProps } from '../_dynamic/constants';

import { tableHead } from './constants';
import ProductItem from './item';

export const PublicOfferTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      tableHeadItems={tableHead}
      tabletColumns={3}
      tabletRows={1}
      mobileFields={[
        { key: 'requestDate', label: 'Solicitação' },
        { key: 'offerType', label: 'Tipo' },
        { key: 'clientName', label: 'Cliente' },
        { key: 'companyName', label: 'Produto' },
        { key: 'offerValue', label: 'Valor' },
        { key: 'statusDescription', label: 'Status' },
      ]}
    />
  );
};
